import React, { useRef } from "react";
import "./Login.css";
import containterCargo from "../assets/images/LogiBill.png";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import { Outlet } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function Login() {
  const navigate = useNavigate();
  const userEmail = useRef(null);
  const userPassword = useRef(null);

  const handleSubmit = async (e) => {
    // navigate("/dashbaord/chalan/chalans");
    e.preventDefault();
    const inputUserEmail = userEmail.current.value;
    const inputUserPassword = userPassword.current.value;
    const response = await fetch(
      //`http://localhost:5000/login/`,
      `${process.env.REACT_APP_BACKEND_URL}/login/`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: inputUserEmail,
          password: inputUserPassword,
        }),
      }
    );
    const json = await response.json();

    if (json.success) {
      //save user data in local session storage
      sessionStorage.setItem("user_auth_token", json.auth_token);

      navigate("/dashbaord/chalan/chalans"); //remove this command
    } else {
      alert("invlaid cardentional");
      navigate("/dashbaord/chalan/chalans");
    }
  };
  return (
    <div className="LoginContainer">
      <div className="LoginPage">
        <div className="loginInfoLeft">
          <img className="mImages" src={containterCargo} alt="Management" />
        </div>
        <div className="LoginFormRight">
          <h2>Login as Admin user</h2>
          <form onSubmit={handleSubmit} className="formContainer">
            <div className="userEmail">
              <input
                type="email"
                ref={userEmail}
                placeholder="admin@gmail.com"
                required={true}
              />
              <PersonOutlineIcon />
            </div>
            <div className="userPassword">
              <input
                type="password"
                ref={userPassword}
                placeholder="Enter password"
                required={true}
              />
              <LockOpenIcon />
            </div>
            <div className="submitButton">
              <input onClick={handleSubmit} type="submit" value={"Login"} />
            </div>
          </form>
        </div>
      </div>

      <Outlet />
    </div>
  );
}

export default Login;
